import React from 'react';
import CubeSpinner from './CubeSpinner';

const initialState = {
  shouldRender: false,
};

interface IProps {
  className?: string;
}
interface IState {
  shouldRender: boolean;
}

class Spinner extends React.PureComponent<IProps, IState> {
  timer: NodeJS.Timeout | undefined = undefined;

  constructor(props: IProps) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    this.timer = setTimeout(this.handleTimeout, 300);
  }

  UNSAFE_componentWillReceiveProps(nextProps: IProps, nextState: IState) {
    if (nextState.shouldRender && this.timer !== undefined) {
      this.timer = undefined;
    }
  }

  componentWillUnmount() {
    if (this.timer) clearTimeout(this.timer);
    this.timer = undefined;
  }

  handleTimeout = () => {
    this.setState({
      shouldRender: true,
    });
  };

  render() {
    const { shouldRender } = this.state;
    const { className } = this.props;
    if (shouldRender) {
      return <CubeSpinner className={className || undefined} />;
    }

    return null;
  }
}

export default Spinner;
